import { Attribute, Module } from "@apis/index";
import Header from "@commons/header";
import ModuleDropdown from "@commons/modules/dropdown";
import Button from "@components/button";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import ButtonWrapper from "@components/wrapper/button-wrapper";
import { RootState } from "@store/index";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormItem } from "./styles";

const AttributeForm = () => {
  const { state } = useLocation();

  const { data: modules } = useSelector((state: RootState) => state.modules);
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    moduleId: "",
    name: "",
    values: "",
  });

  // Fetch modules
  const fetchModule = async () => {
    await Module.list({ state: "modules", params: { isActive: true } });
  };

  useEffect(() => {
    fetchModule();

    // If editing, prefill form
    if (state) {
      setInitialValues({
        moduleId: state.module?.id || "",
        name: state.name || "",
        values: state.values || [],
      });
    } else {
      setInitialValues({ moduleId: "", name: "", values: "" });
    }
  }, [state]);

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const formattedValues = values.values.join(", ");
      const payload = {
        name: values.name,
        moduleId: values.moduleId,
        values: formattedValues,
      };

      if (state?.id) {
        await Attribute.update({
          state: "attributes",
          id: state.id,
          data: payload,
        }).then(() => {
          navigate(`/admin/product-management/attributes`);
        });
      } else {
        await Attribute.create({ state: "attributes", data: payload }).then(
          (res) =>
            navigate(
              `/admin/product-management/attributes?module=${res?.module?.name}`,
            ),
        );
      }

      resetForm();
    } catch (err: any) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <>
      <Header title="Attributes Setup" />
      <Wrapper stylewrapper={`border-radius:12px; padding:24px;`}>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form>
              <Column>
                <Row styleRow="display:flex; gap:20px; align-items:flex-start; margin-bottom:20px">
                  <FormItem>
                    <ModuleDropdown styleInput="width:95.6%" />
                  </FormItem>
                  <FormItem>
                    <Fields.Input
                      name="name"
                      placeholder="Enter attribute (e.g., Size)"
                      label="Attribute"
                    />
                  </FormItem>

                  <FormItem>
                    <Fields.TagInput
                      icon={false}
                      name="values"
                      placeholder="Enter values separated by comma (e.g., S,M,L,XL)"
                      label="Values"
                    />
                  </FormItem>
                </Row>

                <ButtonWrapper>
                  <Button title="Reset" type="reset" variant="reset" />
                  <Button
                    title={state?.id ? "Update Attribute" : "Save Attribute"}
                    type="submit"
                  />
                </ButtonWrapper>
              </Column>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </>
  );
};

export default AttributeForm;
